import ApiService from '../api.service'
import getCurrentCompanyId from '../company.service'
import {
  ICreateEnergyConsumerUnitParams,
  IListEnergyConsumerUnitsParams,
  IUpdateEnergyConsumerUnitParams,
} from '@/interfaces/api/energyConsumerUnit'

const base = () => `/v1/companies/${getCurrentCompanyId()}/energy_consumer_units`

const energyConsumerUnitResource = {
  list: (params?: IListEnergyConsumerUnitsParams) => ApiService.get(base(), params),
  get: (id: number) => ApiService.get(`${base()}/${id}`),
  create: (params: ICreateEnergyConsumerUnitParams) => ApiService.post(base(), params),
  update: (id: number, params: IUpdateEnergyConsumerUnitParams) => ApiService.patch(`${base()}/${id}`, params),
  delete: (id: number) => ApiService.delete(`${base()}/${id}`),
}

export default energyConsumerUnitResource
